var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble",class:{'me': _vm.from == 'me', 'loading': _vm.loading},domProps:{"innerHTML":_vm._s(_vm.loading ? "..." : _vm.text&&_vm.text.split("\n").join("<br>"))}})}
var staticRenderFns = []

export { render, staticRenderFns }